import AccountNSites from "./pages/AccountNSites"
import AddOns from "./pages/AddOns"
import ChargersAndMaterials from "./pages/ChargersAndMaterials"
import Infra from "./pages/Infra"
import LandDeal from "./pages/LandDeal"
import PaymentDetails from "./pages/PaymentDetails"
import PocDetails from "./pages/PocDetails"
import ProjectBasicDetailsWrapper from "./pages/ProjectBasicDetails"
import ProjectDealDetails from "./pages/ProjectDealDetails"
import SaaS from "./pages/Saas"

export enum EProjectFormPages {
    DEAL_TYPE_TEMPLATE = "Deal Type & Template",
    ACCOUNT_N_LOCATION = "Account & Site",
    PROJECT_DETAILS = "Project Details",
    MATERIAL_DETAILS = "Material Details",
    INFRA_DETAILS = "Infra Details",
    SAAS_DETAILS = "SaaS Details",
    LAND_DETAILS = "Land Details",
    ADD_ONS = "Add Ons",
    PAYMENT_DETAILS = "Payment Details",
    ON_GROUND_POC = "On-ground POC",
}

export const PROJECT_FORM_PAGES_TO_FORM_STEPS: Record<EProjectFormPages, React.ComponentType<any>> = {
    [EProjectFormPages.DEAL_TYPE_TEMPLATE]: ProjectDealDetails,
    [EProjectFormPages.ACCOUNT_N_LOCATION]: AccountNSites,
    [EProjectFormPages.PROJECT_DETAILS]: ProjectBasicDetailsWrapper,
    [EProjectFormPages.MATERIAL_DETAILS]: ChargersAndMaterials,
    [EProjectFormPages.INFRA_DETAILS]: Infra,
    [EProjectFormPages.SAAS_DETAILS]: SaaS,
    [EProjectFormPages.LAND_DETAILS]: LandDeal,
    [EProjectFormPages.ADD_ONS]: AddOns,
    [EProjectFormPages.PAYMENT_DETAILS]: PaymentDetails,
    [EProjectFormPages.ON_GROUND_POC]: PocDetails,
}
